export const EMAIL_REGEX = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
export const NAME_REGEX = "^[A-ZÀ-Ýa-zà-ÿ]+(?:[-\' ][A-ZÀ-Ýa-zà-ÿ]+)*$";
